import React from "react";
import { Modal } from "react-bootstrap";
import { CloseIcon } from "../../StrategyCanvasHelpers";
import "./ActionConfirmModal.scss";

// Generic "are you sure" modal for the one-way actions on this screen (Start
// Live Review / Lock Canvas - both flip canvas_state forward with no way
// back). Purpose-built to match this feature's other custom modals
// (Modal.Body + our own header/footer, see LiveReviewInfoModal.js) instead
// of the app's generic ConfirmationPopup, whose bootstrap-default
// header/buttons looked out of place next to those. Same shell every time;
// only icon/copy/labels change per caller.
const ActionConfirmModal = ({
  icon,
  title,
  subtitle,
  text,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}) => (
  <Modal
    show
    onHide={onCancel}
    centered
    dialogClassName="acm-dialog"
    contentClassName="acm-content"
  >
    <Modal.Body className="acm-body">
      <button type="button" className="acm-close" onClick={onCancel} aria-label="Close">
        <CloseIcon />
      </button>

      <div className="acm-header">
        <div className="acm-icon">{icon}</div>
        <div className="acm-heading">
          <h3 className="acm-title">{title}</h3>
          {subtitle && <p className="acm-subtitle">{subtitle}</p>}
        </div>
      </div>

      {text && <p className="acm-text">{text}</p>}

      <div className="acm-divider" />

      <div className="acm-footer">
        <button type="button" className="acm-cancel-btn" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button type="button" className="acm-confirm-btn" onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default ActionConfirmModal;
